import { useState } from 'react';
import api from '../lib/api';

export default function QuickAddAccount({ onAdd, onClose }) {
  const [form, setForm] = useState({
    name:'', address_line1:'', city:'', state:'', zip:'', industry:''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    setError('');
    if (!form.name.trim()) return setError('Account name is required.');
    setSaving(true);
    try {
      const r = await api.post('/accounts', { ...form });
      onAdd(r.data.account);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create account.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      position:'fixed', top:0, left:0, right:0, bottom:0,
      background:'rgba(0,0,0,0.4)', zIndex:2000,
      display:'flex', alignItems:'center', justifyContent:'center'
    }}>
      <div style={{
        background:'var(--bg)', borderRadius:'var(--radius-lg)',
        padding:24, width:480, maxWidth:'90vw',
        border:'0.5px solid var(--border-md)',
        boxShadow:'0 16px 48px rgba(0,0,0,0.2)'
      }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <div style={{ fontSize:15, fontWeight:600 }}>Add new account</div>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer',
                                              color:'var(--text-tertiary)', fontSize:18 }}>✕</button>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
          <div style={{ gridColumn:'span 2' }}>
            <label className="form-label">Account name *</label>
            <input className="form-input" value={form.name}
              onChange={e => setForm({...form, name:e.target.value})}
              placeholder="e.g. Raytheon Co." autoFocus />
          </div>
          <div style={{ gridColumn:'span 2' }}>
            <label className="form-label">Address</label>
            <input className="form-input" value={form.address_line1}
              onChange={e => setForm({...form, address_line1:e.target.value})}
              placeholder="Street address" />
          </div>
          <div>
            <label className="form-label">City</label>
            <input className="form-input" value={form.city}
              onChange={e => setForm({...form, city:e.target.value})}
              placeholder="City" />
          </div>
          <div>
            <label className="form-label">State</label>
            <input className="form-input" value={form.state}
              onChange={e => setForm({...form, state:e.target.value})}
              placeholder="State" />
          </div>
          <div>
            <label className="form-label">ZIP</label>
            <input className="form-input" value={form.zip}
              onChange={e => setForm({...form, zip:e.target.value})}
              placeholder="ZIP code" />
          </div>
          <div>
            <label className="form-label">Industry</label>
            <input className="form-input" value={form.industry}
              onChange={e => setForm({...form, industry:e.target.value})}
              placeholder="e.g. Defense" />
          </div>
        </div>

        {error && <div className="form-error" style={{ marginTop:8 }}>{error}</div>}

        <div style={{ display:'flex', gap:8, marginTop:16 }}>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving…' : 'Create account'}
          </button>
          <button className="btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}